module.exports = __webpack_public_path__ + "static/porqueimg2-fc27650471a0c7cec5b7969dc2cca7b2.jpg";